export const SCREEN_XLARGE = 1280;
export const SCREEN_LARGE = 955;
export const SCREEN_MEDIUM = 620;
export const SCREEN_SMALL = 320;

export const BASE_URL = "https://api.movies-explorer.myrrh.ru";
export const MOVIES_URL = "https://api.nomoreparties.co/beatfilm-movies";
export const MOVIES_BASE_URL = "https://api.nomoreparties.co";

export const NAME_REGEX = /^([A-Za-z\-\s]{1,30})|([А-ЯЁа-яё\-\s]{1,30})$/;
export const EMAIL_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

export const CARDS_ON_XLARGE_SCREEN = 16;
export const CARDS_ON_LARGE_SCREEN = 12;
export const CARDS_ON_MEDIUM_SCREEN = 8;
export const CARDS_ON_SMALL_SCREEN = 5;

export const CARDS_TO_ADD_ON_XLARGE_SCREEN = 4;
export const CARDS_TO_ADD_ON_LARGE_SCREEN = 3;
export const CARDS_TO_ADD_ON_MEDIUM_SCREEN = 2;
export const CARDS_TO_ADD_ON_SMALL_SCREEN = 2;

export const SHORT_MOVIES_DURATION = 40;
